import { TypeDecorator } from '@angular/core';

declare global {
  interface Window {
    prerenderReady: boolean;
  }
}

/**
 * Prerender Ready decorator
 *
 * Use this on static components that can simply trigger the prerender ready flag
 * once they're loaded so that the prerender bot knows it's safe to render the page
 */

function decorateNgAfterViewInit(
  ngAfterViewInit: (() => void) | null | undefined
) {
  return function (this: any) {
    if (ngAfterViewInit) {
      ngAfterViewInit.call(this);
    }

    // FIXME: This is a hack to get around not being able to inject prerender service in a decorator
    if (window) {
      setTimeout(() => {
        window['prerenderReady'] = true;
      }, 750);
    }
  };
}

export function PrerenderReady(): TypeDecorator {
  return (target: any) => {
    target.prototype.ngAfterViewInit = decorateNgAfterViewInit(
      target.prototype.ngAfterViewInit
    );
  };
}
